import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {QuantityWrapper, QuantityBlock} from './Quantity.style';

export class Quantity extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      counter: props.defaultValue
    };
    this.increaseCount = this.increaseCount.bind(this);
    this.decreaseCount = this.decreaseCount.bind(this);
  }

  increaseCount() {
    this.setState({ counter: this.state.counter + 1 }, () => {
      this.props.updateValue(this.state.counter);
    });
  }

  decreaseCount() {
    if (this.state.counter > this.props.minValue) {
      this.setState({ counter: this.state.counter - 1 }, () => {
        this.props.updateValue(this.state.counter);
      });
    }
  }

  render() {
    const {minValue} = this.props;
    return (
      <QuantityWrapper>
        <QuantityBlock
          nonClickable={this.state.counter === minValue}
          onClick={this.decreaseCount}
          data-rw="decrease-quantity-button"
        >−</QuantityBlock>
        <QuantityBlock
          nonClickable
          data-rw="quantity-display"
        >{this.state.counter}</QuantityBlock>
        <QuantityBlock
          onClick={this.increaseCount}
          data-rw="increase-quantity-button"
        >＋</QuantityBlock>
      </QuantityWrapper>
    );
  }
}

Quantity.propTypes = {
  defaultValue: PropTypes.number.isRequired,
  updateValue: PropTypes.func.isRequired,
  minValue: PropTypes.number.isRequired
};

export default Quantity;



// WEBPACK FOOTER //
// ./components/Quantity/Quantity.js